import React, { ReactNode, useState } from "react";
import {
    AttachLmsDocumentsContext,
    IAttachLmsDocumentsContext,
} from "./AttachLmsDocumentsContext";

interface AttachLmsDocumentsProviderProps {
    children: ReactNode;
    /**
     * Optional initial value for selected documents
     */
    initialValue?: IAttachLmsDocumentsContext["value"];
    handleSave: (value: IAttachLmsDocumentsContext["value"]) => void;
}

/**
 * Provider component for AttachLmsDocuments context
 */
export const AttachLmsDocumentsProvider: React.FC<
    AttachLmsDocumentsProviderProps
> = ({ children, initialValue = { folders: [], files: [] }, handleSave }) => {
    /**
     * Update the selected documents
     */
    const handleUpdate = (
        newValue: IAttachLmsDocumentsContext["value"]
    ): void => {
        handleSave(newValue);
    };

    // Create the context value
    const contextValue: IAttachLmsDocumentsContext = {
        value: initialValue,
        handleUpdate,
    };

    return (
        <AttachLmsDocumentsContext value={contextValue}>
            {children}
        </AttachLmsDocumentsContext>
    );
};

export default AttachLmsDocumentsProvider;
